// extracted by mini-css-extract-plugin
module.exports = {"root":"az_ovb","disabled":"az_pvb","labelPlacementStart":"az_qvb","labelPlacementTop":"az_rvb","labelPlacementBottom":"az_svb","label":"az_tvb"};